import { fabric } from 'fabric';
import { isFixedHeight } from 'helpers/textBox';

/**
 * Fixed-height text boxes (see helpers/textBox).
 *
 * A fabric 4 textbox sets its height from its wrapped lines on every layout.
 * One whose metadata has fixed_height keeps the height it has instead: the
 * saved size_y on load, then wherever its top or bottom handle is dragged. So
 * the box can be taller or shorter than its text, and since the export saves
 * size_y from the height, the box height is what the stitcher gets.
 *
 * Patched on fabric.Textbox, which every editor text class extends.
 */

const initDimensions = fabric.Textbox.prototype.initDimensions;

fabric.Textbox.prototype.initDimensions = function () {
  if (this.__skipDimension) return initDimensions.call(this);
  const fixed =
    isFixedHeight(this) && Number.isFinite(this.height) ? this.height : null;
  initDimensions.call(this);
  // what the text itself measures, for the overflow indicator
  this.textHeight = this.height;
  if (fixed !== null) this.height = fixed;
};

// The object cache is sized from width and height and centred on the object,
// so text running past the bottom of a fixed box would be cut off at the box
// edge. Grow it by the overflow on both sides so the bleed stays visible.
const getCacheCanvasDimensions =
  fabric.Textbox.prototype._getCacheCanvasDimensions;

fabric.Textbox.prototype._getCacheCanvasDimensions = function () {
  const dims = getCacheCanvasDimensions.call(this);
  const over = isFixedHeight(this) ? this.textHeight - this.height : 0;
  if (over > 0) dims.height += 2 * over * dims.zoomY;
  return dims;
};

/**
 * Control visibility for the top and bottom handles, which change the height:
 * shown on a fixed box only, unless the object sets its own visibility.
 */
export function fixedHeightControlVisibility(fabricObject, controlKey) {
  const own = fabricObject._controlsVisibility;
  if (own && typeof own[controlKey] !== 'undefined') return own[controlKey];
  return isFixedHeight(fabricObject);
}
